import { render } from "./NoteContent.vue?vue&type=template&id=39ae0c7e&scoped=true"
import script from "./NoteContent.vue?vue&type=script&lang=js"
export * from "./NoteContent.vue?vue&type=script&lang=js"

import "./NoteContent.vue?vue&type=style&index=0&id=39ae0c7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ae0c7e"]])

export default __exports__